import { useEffect, useState } from "react";
import { FaExternalLinkAlt } from "react-icons/fa";
import { getRegulamento } from "services/regulamento.service";

interface RegulamentoLinkProps {
  /** Tipo do regulamento em regulamento__c: `cards`, `mercado_estrelas`, ... */
  type: string;
  label: string;
  className?: string;
}

/**
 * Abre o PDF do regulamento de um tipo específico.
 *
 * Não renderiza nada enquanto não houver regulamento ativo publicado para o tipo,
 * para a tela nunca exibir um link que não leva a lugar algum.
 */
export function RegulamentoLink({
  type,
  label,
  className = "",
}: RegulamentoLinkProps) {
  const [documentUrl, setDocumentUrl] = useState<string>();

  useEffect(() => {
    let montado = true;

    async function carregarRegulamento() {
      const [regulamento] = await getRegulamento(type);
      if (montado) setDocumentUrl(regulamento?.document?.url);
    }

    carregarRegulamento();

    return () => {
      montado = false;
    };
  }, [type]);

  if (!documentUrl) return null;

  return (
    <a
      href={documentUrl}
      target="_blank"
      rel="noreferrer"
      className={`inline-flex items-center gap-2 underline hover:opacity-80 ${className}`}
    >
      <FaExternalLinkAlt size={12} />
      {label}
    </a>
  );
}
